import { useEffect, useRef, useState } from 'react'
import { DebugEventAdder, getPostIdFromUrl } from '../helpers'
import { useLocation } from 'react-router'

type UseDeepLinkHandlerProps = {
    handleDeepLink: (postId: string) => void
    addDebugEvent: DebugEventAdder
}

/**
 * A hook to detect deep links (Hash-based) and execute a provided handler.
 */
export const useDeepLinkHandler = ({
    handleDeepLink,
    addDebugEvent,
}: UseDeepLinkHandlerProps) => {
    const [deepLinkPostId, setDeepLinkPostId] = useState(getPostIdFromUrl())

    const location = useLocation()
    const currentHash = useRef('')

    // Handle deep links from internal nav.
    useEffect(() => {
        if (currentHash.current === location.hash) {
            return
        }
        currentHash.current = location.hash

        const postId = getPostIdFromUrl()
        setDeepLinkPostId(postId)

        if (!postId) {
            return
        }
        addDebugEvent(`Deep link to post ${postId} detected! Handling...`)
        handleDeepLink(postId)
    }, [addDebugEvent, handleDeepLink, location])

    return deepLinkPostId
}
